import { Head, Link, router } from '@inertiajs/react'
import { Badge } from '../../components/ui/badge'
import { ArrowLeft } from 'lucide-react'
import { useState } from 'react'

export default function Index({ grams, total_grams, sort = 'random' }) {
  const [currentSort, setCurrentSort] = useState(sort)

  const handleSortChange = (newSort) => {
    setCurrentSort(newSort)
    router.visit('/all', {
      data: { sort: newSort },
      preserveState: true,
      preserveScroll: true
    })
  }
  return (
    <>
      <Head title="All Pixelgrams" />

      <div className="min-h-screen bg-neutral-100 py-8 px-4">
        <div className="max-w-full mx-auto space-y-6">
          {/* Header */}
          <div className="space-y-4">
            <Link
              href="/"
              className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              <ArrowLeft className="h-4 w-4" />
              Back to Canvas
            </Link>

            <div className="text-center space-y-3">
              <h1 className="text-4xl md:text-5xl font-bold tracking-tight">
                All Pixelgrams
              </h1>
              <div className="flex items-center justify-center gap-2">
                <Badge variant="success" className="text-sm px-3 py-1">
                  {total_grams?.toLocaleString() || 0} pixelgrams sent
                </Badge>
              </div>

              {/* Sorting Toggle */}
              <div className="flex items-center justify-center pt-2">
                <div className="inline-flex rounded-lg border border-neutral-300 bg-white p-1">
                  <button
                    onClick={() => handleSortChange('recent')}
                    className={`px-4 py-1.5 text-sm font-medium rounded-md transition-colors ${
                      currentSort === 'recent'
                        ? 'bg-black text-white'
                        : 'text-neutral-700 hover:bg-neutral-100'
                    }`}
                  >
                    Most Recent
                  </button>
                  <button
                    onClick={() => handleSortChange('random')}
                    className={`px-4 py-1.5 text-sm font-medium rounded-md transition-colors ${
                      currentSort === 'random'
                        ? 'bg-black text-white'
                        : 'text-neutral-700 hover:bg-neutral-100'
                    }`}
                  >
                    Random
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Pixelgrams Grid */}
          {grams && grams.length > 0 ? (
            <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 xl:grid-cols-12 gap-4">
              {grams.map((gram) => (
                <div key={gram.id} className="aspect-square border-2 border-black rounded overflow-hidden hover:shadow-lg transition-shadow">
                  <div className="w-full h-full grid grid-rows-8 grid-cols-8">
                    {gram.pixels.map((row, rowIndex) => (
                      row.map((color, colIndex) => (
                        <div
                          key={`${rowIndex}-${colIndex}`}
                          className="border border-black"
                          style={{ backgroundColor: color }}
                        />
                      ))
                    ))}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="p-12 text-center bg-white rounded-lg">
              <p className="text-muted-foreground">
                No pixelgrams have been sent yet.
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  )
}
